import { render, staticRenderFns } from "./CreditNotes.vue?vue&type=template&id=7353e904&scoped=true&"
import script from "./CreditNotes.vue?vue&type=script&lang=js&"
export * from "./CreditNotes.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotes.vue?vue&type=style&index=0&id=7353e904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353e904",
  null
  
)

export default component.exports